import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding Recap #46: 3D is hard, WebAR defeats me",
  "description": "",
  "published": "2017-09-11T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-46-3d-hard-webar-defeats-me/swizec/7786"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "aLbjwjD92Z4",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`You know what? This 3D stuff is way too hard. None of this makes any sense to me anymore.`}</p>
    <p>{`All I wanted to do today was make a nice little hurricane travel across an augmented reality marker. In theory, all you need for that is a nice particle system and some parameter tweaking. Instead of particles flying around randomly, you want them to twirl around in a cone shape of some sort.`}</p>
    <p>{`But noooo…`}</p>
    <p>{`We tried with `}<a parentName="p" {...{
        "href": "https://github.com/IdeaSpaceVR/aframe-particle-system-component"
      }}>{`aframe-particle-system-component`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/09/particles-1.gif",
        "alt": null
      }}></img></p>
    <p>{`That did not quite work.`}</p>
    <p>{`Then we searched for `}<a parentName="p" {...{
        "href": "https://threejs.org/examples/"
      }}>{`three.js examples`}</a>{` that looked close enough that they could be a hurricane with some param tweaking. The closest we could find was the `}<a parentName="p" {...{
        "href": "https://threejs.org/examples/#webgl_gpu_particle_system"
      }}>{`GPU Particle System example`}</a>{`.`}</p>
    <p>{`It's got everything we need:`}</p>
    <ol>
      <li parentName="ol">{`Many particles`}</li>
      <li parentName="ol">{`Particles follow some sort of wind pattern`}</li>
      <li parentName="ol">{`Parameters to tweak`}</li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/09/gpu-particles-system-1024x687.gif",
        "alt": null
      }}></img></p>
    <p>{`Turning it into an `}<a parentName="p" {...{
        "href": "https://aframe.io/"
      }}>{`aframe component`}</a>{` for `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/ar-js-experiment"
      }}>{`our setup`}</a>{` should be easy. Aframe is an abstraction on top of Three.js, after all.`}</p>
    <p><em parentName="p">{`In theory`}</em>{`, all you have to do is to register a new Aframe component, put your example initiation into `}<inlineCode parentName="p">{`init()`}</inlineCode>{`, and your animation stuff into `}<inlineCode parentName="p">{`tick()`}</inlineCode>{`. Instead of rendering with the Three.js renderer, you `}<inlineCode parentName="p">{`setObject3D`}</inlineCode>{` on the Aframe object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`AFRAME.registerComponent("hurricane", {
  scheme: {},
  init: function () {
    // initiation code
  },
  tick: function (now, delta) {
    // animation code
  },
});
`}</code></pre>
    <p>{`Then you could use it like this: `}<inlineCode parentName="p">{`<Entity hurricane />`}</inlineCode>{`, or without JSX, like this: `}<inlineCode parentName="p">{`<a-entity hurricane />`}</inlineCode>{`.`}</p>
    <p>{`It didn't work. We tried fiddling with it and changing things here and there and nothing worked. No matter what, nothing showed up on screen.`}</p>
    <p>{`In a final act of defiance, we found this cool `}<a parentName="p" {...{
        "href": "https://github.com/feiss/aframe-environment-component"
      }}>{`aframe-environment-component`}</a>{` and put a giant mushroom forest around our Minecraft guy.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`But this is cool too `}<a parentName="p" {...{
          "href": "https://t.co/hjdUKhnEyY"
        }}>{`pic.twitter.com/hjdUKhnEyY`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/907022919028457472"
      }}>{`September 10, 2017`}</a></blockquote>
    <p>{`I guess that's cool, too. I dunno, I'm kinda disappointed. I was hoping we could build something cool, but this whole 3D-on-the-web business is almost as big a mess as all the D3 examples you find out there.`}</p>
    <p>{`What is it with everybody who writes these examples and relying on global variables for everything? Use function arguments, damn it! That's what they're there for 😖`}</p>
    <p>{`And what's with all the imperative code? Everything is just add this and this and this and then change this and that. How am I supposed to understand what's going on?`}</p>
    <p>{`Ugh ... we'll play with something new next week. Any suggestions?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      